import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import { globalColors } from '../../../common/utilities/style-constants';
import SadMagnifyingGlass from '../../images/sad_magnifying_glass.png';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: '100%',
    textAlign: 'center',
  },
  imageContainer: {
    height: '39%',
  },
  image: {
    width: '85%',
    marginTop: '-100px',
  },
  title: {
    fontSize: '50px',
  },
  text: {
    fontWeight: 'bold',
    padding: '0 30%',
    opacity: '0.75',
    fontSize: '16px',
  },
  button: {
    marginTop: '35px',
    background: globalColors.button,
    borderRadius: '5px',
    color: 'white',
    cursor: 'pointer',
    textTransform: 'none',
    padding: '5px 60px',
    '&:hover': {
      backgroundColor: globalColors.buttonHover,
    },
  },
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = { errorInfo: null };
  }

  componentDidCatch(errorInfo) {
    this.setState({
      errorInfo,
    });
  }

  render() {
    const { errorInfo } = this.state;
    const { classes, children } = this.props;

    if (errorInfo) {
      // eslint-disable-next-line no-console
      console.error(errorInfo);

      return (
        <div className={classes.container}>
          <div className={classes.imageContainer}>
            <img className={classes.image} src={SadMagnifyingGlass} alt="Bright" />
          </div>
          <h1 className={classes.title}>Oops!</h1>
          <p className={classes.text}>It looks like something went wrong! Feel free to refresh your page or click back to try again. You can email us at support@learnwithbright.com if the issue arises again.</p>
          <Button
            className={classes.button}
            type="button"
            onClick={() => { window.location.href = '/'; }}
          >
            Go Home
          </Button>
        </div>
      );
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    container: PropTypes.string,
    imageContainer: PropTypes.string,
    image: PropTypes.string,
    button: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
  }).isRequired,
};

export default withStyles(styles)(ErrorBoundary);
